import React from 'react';
import { useNavigate } from "react-router-dom";
import { Card, Row, Col } from 'antd';
import AddNewWebsiteIndexEntryButton from '../websiteIndexEntry/addNewWebsite/AddNewWebsiteIndexEntryButton';
import "./NoWebsites.less";

const { Meta } = Card;

const layoutSettings = [
    {
        pathname: '/deep-analysis',
        iconClassName: 'deep-analysis',
        title: 'Deep Analysis',
        description: 'Perform a Deep Analysis of your site',
    },
    {
        pathname: '/analysis',
        iconClassName: 'seo-check',
        title: 'SEO Checkup',
        description: 'Perform a SEO Checkup analysis for your site',
    },
    {
        pathname: '/backlinks',
        iconClassName: 'backlinks',
        title: 'Backlinks',
        description: "Check your website's backlinks",
    },
    {
        pathname: '/top-keywords',
        iconClassName: 'top-keywords',
        title: 'Top Keywords',
        description: "Check your website's top keywords",
    },
    {
        pathname: '/keyword-research',
        iconClassName: 'research',
        title: 'Keyword Research',
        description: "Find new keywords for your content",
    },
    {
        pathname: '/site-speed',
        iconClassName: 'speed',
        title: 'Site Loading Speed',
        description: "Check your website's performance",
    },
    {
        pathname: '/site-outage',
        iconClassName: 'uptime',
        title: 'Site Outage',
        description: "Check your website's uptime status",
    },
    {
        pathname: '/white-label/reports',
        iconClassName: 'brand',
        title: 'White Label Reports',
        description: 'Get customized SEO reports',
    }
];

export default function NoWebsites() {
    const navigate = useNavigate();

    const handleClick = (event: any) => {
        const pathname = event.currentTarget.getAttribute('data-target');
        navigate(pathname);
    };

    const servicesColumns = layoutSettings.map((service, index) => (
        <Col
            key={index}
            sm={24}
            lg={12}
            xl={8}
        >
            <Meta
                data-target={service.pathname}
                className="empty-dashboard-box"
                avatar={
                    <span className="custom-icon icon">
                        <span className={`icon custom-icon-${service.iconClassName}`}></span>
                    </span>
                }
                title={service.title}
                description={service.description} // @ts-ignore no onClick prop for Meta
                onClick={handleClick}
            />
        </Col>
    ));

    return (
        <Card
            title={
                <div className="ant-card-meta-detail">
                    <div className="ant-card-meta-title">Welcome to SEO ToolBox!</div>
                    <div className="ant-card-meta-description">Let's start improving your SEO</div>
                </div>
            }
        >
            <p style={{ marginBottom: '5px' }}>Setup your account in order to have a better SEO Site Checkup Toolbox experience.</p>
            <p>
                After the setup process you will have access to your Toolbox Dashboard, where you could see detailed information regarding your website's SEO
                performances.
            </p>

            <AddNewWebsiteIndexEntryButton label="Setup your account" />
            <Row
                gutter={[
                    { xs: 8, sm: 16, md: 24, lg: 24 },
                    { xs: 8, sm: 16, md: 24, lg: 24 },
                ]}
                style={{ marginTop: '24px' }}
            >
                {servicesColumns}
            </Row>
        </Card>
    );
}
